import * as $runtime from "../runtime.js";
import * as Data$dArray$dNonEmpty$dInternal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
const $DeliveryStatus = (tag, _1) => ({tag, _1});
const showRecord1 = {
  show: record => "{ deliveryCost: " + Data$dMoney$dRounded.toString(record.deliveryCost) + (() => {
    if (record.freeThreshold.tag === "Just") {
      return ", freeThreshold: (Just " + Data$dMoney$dRounded.toString(record.freeThreshold._1) + ")" + ", minOrderValue: " + Data$dMoney$dRounded.toString(record.minOrderValue) + ", path: " + Data$dShow.showStringImpl(record.path) + ", restaurantId: " + Data$dShow.showIntImpl(record.restaurantId) + ", restaurantName: " + Data$dShow.showStringImpl(record.restaurantName) + ", restaurantSlug: " + Data$dShow.showStringImpl(record.restaurantSlug) + " ";
    }
    if (record.freeThreshold.tag === "Nothing") {
      return ", freeThreshold: Nothing, minOrderValue: " + Data$dMoney$dRounded.toString(record.minOrderValue) + ", path: " + Data$dShow.showStringImpl(record.path) + ", restaurantId: " + Data$dShow.showIntImpl(record.restaurantId) + ", restaurantName: " + Data$dShow.showStringImpl(record.restaurantName) + ", restaurantSlug: " + Data$dShow.showStringImpl(record.restaurantSlug) + " ";
    }
    $runtime.fail();
  })() + "}"
};
const eq1 = /* #__PURE__ */ Data$dEq.eqArrayImpl(ra => rb => ra.deliveryCost === rb.deliveryCost && (() => {
  if (ra.freeThreshold.tag === "Nothing") { return rb.freeThreshold.tag === "Nothing"; }
  if (ra.freeThreshold.tag === "Just") {
    if (rb.freeThreshold.tag === "Just") { return ra.freeThreshold._1 === rb.freeThreshold._1; }
    return false;
  }
  return false;
})() && ra.minOrderValue === rb.minOrderValue && ra.path === rb.path && ra.restaurantId === rb.restaurantId && ra.restaurantName === rb.restaurantName && ra.restaurantSlug === rb.restaurantSlug);
const WontDeliver = /* #__PURE__ */ $DeliveryStatus("WontDeliver");
const Ok = value0 => $DeliveryStatus("Ok", value0);
const ChangeRestaurant = value0 => $DeliveryStatus("ChangeRestaurant", value0);
const genericDeliveryStatus = {
  to: x => {
    if (x.tag === "Inl") { return WontDeliver; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $DeliveryStatus("Ok", x._1._1); }
      if (x._1.tag === "Inr") { return $DeliveryStatus("ChangeRestaurant", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "WontDeliver") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Ok") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ChangeRestaurant") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showDeliveryStatus = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "WontDeliver"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $1 = Data$dArray$dNonEmpty$dInternal.showNonEmptyArray(showRecord1);
      return {genericShowArgs: v => [$1.show(v)]};
    })())({reflectSymbol: () => "Ok"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ deliveryInfo: " + showRecord1.show(v.deliveryInfo) + ", path: " + Data$dShow.showStringImpl(v.path) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + ", restaurantName: " + Data$dShow.showStringImpl(v.restaurantName) + " " + "}"
      ]
    })({reflectSymbol: () => "ChangeRestaurant"});
    return x => {
      const $3 = genericDeliveryStatus.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const fromOk = restaurantId => v => {
  if (v.tag === "Ok") { return Data$dFoldable.find(Data$dFoldable.foldableArray)(di => restaurantId === di.restaurantId)(v._1); }
  return Data$dMaybe.Nothing;
};
const eqDeliveryStatus = {
  eq: x => y => {
    if (x.tag === "WontDeliver") { return y.tag === "WontDeliver"; }
    if (x.tag === "Ok") {
      if (y.tag === "Ok") { return eq1(x._1)(y._1); }
      return false;
    }
    if (x.tag === "ChangeRestaurant") {
      if (y.tag === "ChangeRestaurant") {
        return x._1.deliveryInfo.deliveryCost === y._1.deliveryInfo.deliveryCost && (() => {
          if (x._1.deliveryInfo.freeThreshold.tag === "Nothing") { return y._1.deliveryInfo.freeThreshold.tag === "Nothing"; }
          if (x._1.deliveryInfo.freeThreshold.tag === "Just") {
            if (y._1.deliveryInfo.freeThreshold.tag === "Just") { return x._1.deliveryInfo.freeThreshold._1 === y._1.deliveryInfo.freeThreshold._1; }
            return false;
          }
          return false;
        })() && x._1.deliveryInfo.minOrderValue === y._1.deliveryInfo.minOrderValue && x._1.deliveryInfo.path === y._1.deliveryInfo.path && x._1.deliveryInfo.restaurantId === y._1.deliveryInfo.restaurantId && x._1.deliveryInfo.restaurantName === y._1.deliveryInfo.restaurantName && x._1.deliveryInfo.restaurantSlug === y._1.deliveryInfo.restaurantSlug && x._1.path === y._1.path && x._1.restaurantId === y._1.restaurantId && x._1.restaurantName === y._1.restaurantName;
      }
      return false;
    }
    return false;
  }
};
const deliveryCostOrFree = v => v1 => {
  if (v1.tag === "Nothing") { return Data$dMaybe.Nothing; }
  if (v1.tag === "Just") {
    return Data$dMaybe.$Maybe(
      "Just",
      (() => {
        if (v1._1.freeThreshold.tag === "Nothing") { return v1._1.deliveryCost; }
        if (v1._1.freeThreshold.tag === "Just") {
          if (v >= v1._1.freeThreshold._1) { return 0; }
          return v1._1.deliveryCost;
        }
        $runtime.fail();
      })()
    );
  }
  $runtime.fail();
};
export {$DeliveryStatus, ChangeRestaurant, Ok, WontDeliver, deliveryCostOrFree, eq1, eqDeliveryStatus, fromOk, genericDeliveryStatus, showDeliveryStatus, showRecord1};
